import api from '../utils/api';
import config from '../config';

const approvalAccountService = {
  // Get init data (approval account types)
  getInit: async () => {
    return api.get(config.endpoints.approvalAccounts.init);
  },

  // Get approval accounts list by type with pagination
  getApprovalAccounts: async (type, page, pageSize) => {
    return api.get(config.endpoints.approvalAccounts.list, { type, page, pageSize });
  },

  // Delete approval account
  deleteApprovalAccount: async (id) => {
    return api.delete(`${config.endpoints.approvalAccounts.delete}/${id}`);
  },

  // Bulk delete approval accounts
  bulkDeleteApprovalAccounts: async (ids) => {
    return api.delete(config.endpoints.approvalAccounts.delete, {
      params: { ids },
      paramsSerializer: {
        indexes: null, // Use repeat format: ?ids=1&ids=2 instead of ?ids[0]=1&ids[1]=2
      },
    });
  },

  // Get unassigned users by type with pagination
  getUnassignedUsers: async (type, page, pageSize) => {
    return api.get(config.endpoints.approvalAccounts.unassign, { type, page, pageSize });
  },

  // Assign users to approval account type
  assignUsers: async (type, userIds) => {
    return api.post(`${config.endpoints.approvalAccounts.assign}?type=${type}`, { userIds });
  },
};

export default approvalAccountService;
